module.exports = __webpack_public_path__ + "164dd89b80661e22dc53982685491450.svg";